export default "__VITE_ASSET__C8pe7dpu__"